import React from 'react';
import { FaSpinner } from 'react-icons/fa';
import styles from './Loader.module.css';

interface LoaderProps {
    size?: number;
    className?: string;
}

const Loader: React.FC<LoaderProps> = ({ size = 40, className }) => {
    return (
        <div className={`${styles.loaderContainer} ${className || ''}`}>
            <FaSpinner size={size} className={styles.spinner} />
        </div>
    );
};

export default Loader;
